<template>
  <div class="w-full">
    <input
      :type="type"
      :name="name"
      :value="value"
      @input="$emit('update-value', $event.target.value)"
      class="relative z-0 w-full px-5 py-4 rounded-full appearance-none bg-zinc-100 focus:outline-secondary"
      :placeholder="placeholder"
    />
    <p v-show="show_error" class="text-xs text-red-600">
      {{ error_message }}
    </p>
  </div>
</template>

<script>
export default {
  name: "CheckoutTextField",
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
      default: "",
    },
    show_error: {
      type: Boolean,
    },
    error_message: {
      type: String,
    },
  },
};
</script>
